// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"theme12_breadcrumbs__t4D2a","separator":"theme12_separator__rCk1v"};